import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstLetterUpper'
})
export class FirstLetterUpperPipe implements PipeTransform {

    transform(word: string) {
        if (!word || typeof(word) === 'number') return word;
        return word[0].toUpperCase() + word.substr(1).toLowerCase();
    }

}
